<script>
export default {
  name: 'Course_B_Menu',
  props: {
    total: {
      type: Number,
      required: true,
    },
    currentIndex: {
      type: Number,
      required: true,
    },
    setIndex: {
      type: Function,
      required: true,
    },
  },
}
</script>
<style lang="scss" scoped>
    ul {
        margin-bottom: -.05em;
        li {
            &:last-child {
                margin-right: -.05em;
            }

            a {
                background: #eeeff3;
                color: #cdced2;
                &.active,
                &:hover {
                    background: white;
                    color: #d3be9f !important;
                }
            }
        }
    }
</style>
<template>
    <ul class="d-flex justify-content-between">
        <li v-for="i in total" :key="i">
            <a @click="setIndex(i - 1)" class="d-block rounded-top p-3 pointer" :class="{active: currentIndex === (i - 1)}">
                CZĘŚĆ {{ i }}
            </a>
        </li>
    </ul>
</template>
